<template>
  <div class="campus-form-page">
    <b-container fluid class="px-2 px-md-3">
      <b-card class="campus-header-card">
        <div class="campus-header">
          <b-button
            variant="outline-secondary"
            class="btn-icon back-btn"
            @click="BacktoGrid()"
          >
            <feather-icon icon="ArrowLeftIcon" size="16" />
          </b-button>
          <div class="title-wrapper">
            <div class="d-flex align-items-center flex-wrap">
              <h4 class="mb-0 mr-1">
                {{ myObj.id > 0 ? $t("Edit Campus") : $t("Add Campus") }}
              </h4>
              <b-badge
                v-if="myObj.campusCode"
                variant="light-primary"
                class="badge-pill text-uppercase"
              >
                {{ myObj.campusCode }}
              </b-badge>
              <b-badge v-else variant="light-secondary" class="badge-pill">
                {{ myObj.id > 0 ? $t("Edit") : $t("New") }}
              </b-badge>
            </div>
            <small class="text-muted">
              {{ $t("Institute profile, logo, and cover") }}
            </small>
          </div>
          <div class="header-actions">
            <b-button
              variant="outline-secondary"
              class="cancel-btn"
              @click="BacktoGrid()"
            >
              {{ $t("Cancel") }}
            </b-button>
            <b-button
              variant="success"
              class="save-campus-btn"
              :disabled="request"
              @click="Add()"
            >
              <b-spinner v-if="request" small class="mr-50" />
              <feather-icon v-else icon="SaveIcon" size="16" class="mr-50" />
              {{ $t("Save") }}
            </b-button>
          </div>
        </div>
      </b-card>

      <b-card class="campus-form-card">
        <div class="form-section">
          <div class="section-head">
            <feather-icon icon="ImageIcon" size="18" class="text-primary" />
            <div>
              <h5 class="section-head__title mb-0">
                {{ $t("Branding") }}
              </h5>
              <small class="text-muted">{{
                $t("Cover appears on campus cards; logo is the round badge")
              }}</small>
            </div>
          </div>

          <div class="campus-branding">
            <div
              class="campus-form-cover"
              :class="{ 'campus-form-cover--has-image': !!myObj.cover }"
            >
              <img
                v-if="myObj.cover"
                :src="myObj.cover"
                alt=""
                class="campus-form-cover__img"
              />
              <div v-else class="campus-form-cover__placeholder">
                <feather-icon icon="ImageIcon" size="32" />
                <span>{{ $t("Campus cover image") }}</span>
              </div>
              <div v-if="coverLoading" class="campus-form-cover__loading">
                <b-spinner variant="light" />
              </div>
              <div class="campus-form-cover__actions">
                <b-button
                  size="sm"
                  variant="light"
                  class="cover-action-btn"
                  @click="$refs.fileCover.click()"
                  :disabled="coverLoading"
                >
                  <feather-icon icon="UploadIcon" size="14" class="mr-50" />
                  {{ myObj.cover ? $t("Change cover") : $t("Upload cover") }}
                </b-button>
                <b-button
                  v-if="myObj.cover"
                  size="sm"
                  variant="outline-light"
                  class="cover-action-btn ml-50"
                  @click="deleteCover()"
                >
                  {{ $t("Remove") }}
                </b-button>
              </div>
              <input
                ref="fileCover"
                type="file"
                hidden
                accept="image/*"
                @change="selectCover()"
              />
            </div>

            <div class="campus-form-logo-block">
              <div class="campus-form-logo-wrap">
                <div v-if="logoloading === true" class="campus-form-logo__spin">
                  <b-spinner variant="primary" />
                </div>
                <img
                  v-else-if="showLogoPreview"
                  :src="plus"
                  alt="Logo"
                  class="campus-form-logo__img"
                  @error="onLogoPreviewError"
                />
                <div
                  v-else
                  class="campus-form-logo__empty"
                  @click="$refs.fileProfile.click()"
                >
                  <feather-icon icon="CameraIcon" size="22" />
                </div>
                <b-button
                  v-if="showLogoPreview"
                  size="sm"
                  variant="danger"
                  class="campus-form-logo__remove btn-icon rounded-circle"
                  @click="deleteLogo()"
                >
                  <feather-icon icon="Trash2Icon" size="14" />
                </b-button>
              </div>
              <div class="campus-form-logo__hint">
                <span class="logo-label">{{ $t("Logo") }}</span>
               
                <b-button
                  size="sm"
                  variant="outline-primary"
                  class="logo-upload-btn"
                  @click="$refs.fileProfile.click()"
                >
                  <feather-icon icon="UploadIcon" size="14" class="mr-50" />
                  {{ showLogoPreview ? $t("Change logo") : $t("Upload logo") }}
                </b-button>
              </div>
              <input
                ref="fileProfile"
                type="file"
                hidden
                accept="image/*"
                @change="selectlogo()"
              />
            </div>
          </div>
          <small v-if="logoerror" class="text-danger d-block mt-50">{{
            $t("Logo is required.")
          }}</small>
        </div>

        <div class="form-section form-section--fields">
          <div class="section-head">
            <feather-icon icon="HomeIcon" size="18" class="text-primary" />
            <div>
              <h5 class="section-head__title mb-0">
                {{ $t("Campus details") }}
              </h5>
              <small class="text-muted">{{
                $t("Required fields are marked with *")
              }}</small>
            </div>
          </div>

          <b-form @submit.prevent="Add()" class="campus-fields-form">
            <b-row>
              <b-col md="6">
                <b-form-group
                  class="campus-field-group"
                  :label="$t('School name') + ' *'"
                  :invalid-feedback="$t('School name is required')"
                >
                  <b-form-input
                    class="campus-field-input"
                    :placeholder="$t('Enter school name')"
                    ref="name"
                    v-model="myObj.name"
                    @focusout="CheckName()"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  class="campus-field-group"
                  :label="$t('Branch name') + ' *'"
                  :invalid-feedback="$t('Branch name is required')"
                >
                  <b-form-input
                    class="campus-field-input"
                    :placeholder="$t('Enter branch name')"
                    ref="branch"
                    v-model="myObj.branch"
                    @focusout="CheckBranch()"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  class="campus-field-group"
                  :label="$t('Campus code')"
                >
                  <b-form-input
                    class="campus-field-input campus-field-input--code"
                    v-model="myObj.campusCode"
                    :placeholder="$t('e.g. HO, COC-01')"
                    maxlength="50"
                    @input="
                      myObj.campusCode = (myObj.campusCode || '').toUpperCase()
                    "
                  />
                  <small class="field-hint">{{
                    $t("Optional short code for reports and cards")
                  }}</small>
                </b-form-group>
              </b-col>

              <b-col md="12" v-if="isIussDomain">
                <b-form-group
                  class="campus-field-group"
                  :label="$t('Companies')"
                >
                  <v-select
                    v-model="selectedCompanyIds"
                    class="campus-companies-select"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="companySelectOptions"
                    :reduce="(op) => op.id"
                    label="label"
                    multiple
                    :placeholder="$t('Link campus to companies (optional)')"
                  />
                  <small class="field-hint">{{
                    $t(
                      "Used on IUSS to filter which campuses users can switch to."
                    )
                  }}</small>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  class="campus-field-group"
                  :label="$t('Phone number') + ' *'"
                  invalid-feedback="Please enter correct phone number."
                >
                  <div class="campus-tel-wrap">
                    <vue-tel-input
                      v-model="myObj.phone"
                      :inputOptions="{
                        placeholder: $t('Enter a phone number'),
                      }"
                      :dropdownOptions="dropOptions"
                      :defaultCountry="$store.state.countryCode"
                    />
                  </div>
                  <small class="text-danger" v-if="phoneerror">{{
                    $t("Phone number is required")
                  }}</small>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  class="campus-field-group"
                  :label="$t('Mobile number') + ' *'"
                  invalid-feedback="Please enter correct mobile."
                >
                  <div class="campus-tel-wrap">
                    <vue-tel-input
                      v-model="myObj.mobile"
                      :inputOptions="{
                        placeholder: $t('Enter a phone number'),
                      }"
                      :dropdownOptions="dropOptions"
                      :defaultCountry="$store.state.countryCode"
                    />
                  </div>
                  <small class="text-danger" v-if="mobileerror">{{
                    $t("Mobile number is required")
                  }}</small>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  class="campus-field-group"
                  :label="$t('Email') + ' *'"
                  :invalid-feedback="$t('Email address is required')"
                >
                  <b-form-input
                    class="campus-field-input"
                    ref="email"
                    type="email"
                    placeholder="myskool@example.com"
                    v-model="myObj.email"
                    @focusout="CheckEmail()"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  class="campus-field-group"
                  :label="$t('Website (optional)')"
                  :invalid-feedback="$t('Website is required')"
                >
                  <b-form-input
                    class="campus-field-input"
                    ref="website"
                    placeholder="www.myskool.com"
                    v-model="myObj.website"
                    @focusout="CheckWebsite()"
                  />
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  class="campus-field-group"
                  :label="$t('Address') + ' *'"
                  :invalid-feedback="$t('Address is required')"
                >
                  <b-form-input
                    class="campus-field-input"
                    :placeholder="$t('Address')"
                    v-model="myObj.address"
                    ref="address"
                    @focusout="CheckAddress()"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BInputGroupPrepend,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BContainer,
  BMediaAside,
  BAside,
  BSpinner,
  BInputGroup,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
//import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from "@core/utils/filter";
//import useAllOrdersList from './useAllOrdersList'
//import orderStoreModule from '../allordersStoreModule'
import flatPickr from "vue-flatpickr-component";
import { BFormSelect } from "bootstrap-vue";
//import Multiselect from "vue-multiselect";
import VueGallery from "vue-gallery";
import { TheMask } from "vue-the-mask";
import { mapActions, mapGetters } from "vuex";
import { getUploadPath, uploadToMySkool } from "@/utils/gdriveUpload";
import {
  parseCompanyIds,
  formatCompanyIds,
} from "@/utils/companyIds";

export default {
  components: {
    //Multiselect,
    TheMask,
    BInputGroup,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BFormGroup,
    BInputGroupPrepend,
    // BFormCheckbox,
    BForm,
    BContainer,
    BMediaAside,
    BImg,
    BMedia,
    //BAvatar,
    BLink,
    BSpinner,
    BBadge,
    vSelect,
    // BDropdown,
    //BDropdownItem,
    //BPagination,
    //vSelect,
    //flatPickr,
    //'gallery': VueGallery
  },

  props: ["row"],
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  created() {
    this.myrow = this.$route.params.row;
    // console.log(this.$route.params.row);
    this.LoadForm();
    if (this.isIussDomain) {
      this.loadCompanies();
    }
  },
  computed: {
    isIussDomain() {
      return this.$store.state.report.replace(/_/g, "") === "myskooliuss";
    },
    companySelectOptions() {
      return (this.companies || []).map((c) => ({
        id: c.id,
        label: [c.code, c.name].filter(Boolean).join(" — "),
      }));
    },
    showLogoPreview() {
      return (
        this.logoloading === "loaded" &&
        !!this.plus &&
        !this.logoPreviewFailed
      );
    },
  },
  data() {
    return {
      dropOptions: {
        disabled: false,
        showDialCodeInList: true,
        showFlags: true,
      },
      myrow: "",
      logoerror: false,
      phoneerror: false,
      mobileerror: false,

      plus: "",
      logoloading: false,
      logoPreviewFailed: false,
      coverLoading: false,
      request: false,
      searchQuery: "",
      currentPage: 1,
      totalRows: 0,

      errors: {
        status: false,
      },
      statusOptions: ["In stock", "Out stock"],
      filterData: "",
      date: {
        range: "",
      },
      index: null,
      cover: "",
      docs: [],
      partners: [],
      fields: [
        "#",
        { label: "Flavour", key: "Name" },
        { label: "Status", key: "Status" },
        "actions",
      ],
      items: [],
      selected: null,

      rangeDate: null,
      myObj: {
        id: 0,
        name: "",
        branch: "",
        address: "",
        phone: "",
        mobile: "",
        email: "",
        website: "",
        logo: "",
        cover: "",
        companyIDs: null,
        campusCode: "",
      },
      companies: [],
      selectedCompanyIds: [],
      detailObj: {},
      limit: this.$store.state.branches[0].limit,
      // limit: 0,
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    async loadCompanies() {
      try {
        const rows = await this.get({
          url:
            this.$store.state.domain +
            "Companies?db=" +
            encodeURIComponent(this.$store.state.userData.db) +
            "&cID=" +
            this.$store.state.userData.cId,
          token: this.$store.state.userData.token,
        });
        this.companies = Array.isArray(rows) ? rows : [];
      } catch (e) {
        this.companies = [];
      }
    },
    syncCompanySelectionFromCampus() {
      this.selectedCompanyIds = parseCompanyIds(this.myObj.companyIDs);
    },
    applyCompanyIdsBeforeSave() {
      if (!this.isIussDomain) return;
      this.myObj.companyIDs = formatCompanyIds(this.selectedCompanyIds);
    },

    onLogoPreviewError() {
      this.logoPreviewFailed = true;
    },
    deleteLogo() {
      this.myObj.logo = "";
      this.plus = "";
      this.logoPreviewFailed = false;
      this.logoloading = false;
    },
    deleteCover() {
      this.myObj.cover = "";
    },
    async selectCover() {
      const file = this.$refs.fileCover && this.$refs.fileCover.files[0];
      if (!file) return;
      this.coverLoading = true;
      try {
        const uploaded = await uploadToMySkool([file]);
        this.myObj.cover = getUploadPath(uploaded[0]);
      } catch (err) {
        console.log(err);
        this.$bvToast.toast(this.$t("Cover upload failed."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } finally {
        this.coverLoading = false;
        if (this.$refs.fileCover) this.$refs.fileCover.value = "";
      }
    },
    async selectlogo() {
      this.fileProfile = this.$refs.fileProfile.files[0];
      if (!this.fileProfile) return;
      this.logoloading = true;
      try {
        const uploaded = await uploadToMySkool([this.fileProfile]);
        const fn1 = getUploadPath(uploaded[0]);
        this.plus = fn1;
        this.myObj.logo = this.plus;
        this.logoPreviewFailed = false;
        this.logoloading = "loaded";
        this.logoerror = false;
      } catch (err) {
        console.log(err);
        this.logoloading = false;
      }
    },
    CheckLogo() {
      var elem = this.$refs["picture"];
      if (this.myObj.logo == "") {
        return (this.logoerror = true);
      } else {
        return (this.logoerror = false);
      }
    },
    CheckWebsite() {
      var elem = this.$refs["website"];
      //elem.state = false;
      var re =
        /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
      if (this.myObj.website === "") {
        return (elem.state = undefined);
      } else {
        return (elem.state = true);
        // if (re.test(this.myObj.website)) {
        //   return (elem.state = true);
        // } else {
        //   return (elem.state = false);
        // }
      }
    },
    CheckEmail() {
      var elem = this.$refs["email"];
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (
        re.test(String(this.myObj.email).toLowerCase()) &&
        this.myObj.email !== ""
      ) {
        return (elem.state = true);
      } else {
        return (elem.state = false);
      }
    },
    CheckName() {
      var elem = this.$refs["name"];
      if (this.myObj.name < 3 || this.myObj.name == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckAddress() {
      var elem = this.$refs["address"];
      if (this.myObj.address < 3 || this.myObj.address == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckBranch() {
      var elem = this.$refs["branch"];
      if (this.myObj.branch < 3 || this.myObj.branch == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckPhone(s, e) {
      // console.log(e);
      // if (this.myObj.phone) {
      //   if (e.valid) {
      //     this.phoneerror = false;
      //     this.myObj.phone = e.number;
      //     // console.log(this.myObj.phone);
      //   } else {
      //     this.phoneerror = true;
      //   }
      // } else {
      //   this.phoneerror = false;
      // }
      if (this.myObj.phone !== "" && this.myObj.phone.startsWith("03")) {
        if (this.myObj.phone.length == 12) {
          return (this.phoneerror = false);
        } else {
          return (this.phoneerror = true);
        }
      }
      return false;
    },
    CheckMobile() {
      if (this.myObj.mobile !== "") {
        if (this.myObj.mobile.length == 12) {
          return (this.mobileerror = false);
        } else {
          return (this.mobileerror = true);
        }
      }
      return false;
      // var elem = this.$refs['mobile'];
      // var re = /^(\+92|0|92)[0-9]{10}$/;
      // if (re.test(this.myObj.mobile) && this.myObj.mobile !== '') {
      //   return (this.mobileerror = false);
      // } else {
      //   return (this.mobileerror = true);
      // }
    },
    BacktoGrid() {
      this.$router.push("/manage-branches");
    },
    checkTitle() {
      var elem = this.$refs["title"];
      return (elem.state = this.myObj.Name.length > 2 ? true : false);
    },
    checkStatus() {
      if (this.myObj.Status == "") {
        return (this.errors.status = true);
      } else {
        return (this.errors.status = false);
      }
    },
    OpenAddModal() {
      this.$bvModal.show("modal-login");
      this.myObj.flavourId = 0;
      this.myObj.vendorId = this.$store.state.userData.userID;
      this.myObj.Name = "";
      this.myObj.Status = "";
    },
    OpenEditModal(row) {
      this.$bvModal.show("modal-login");
      this.myObj.flavourId = row.flavourId;
      this.myObj.vendorId = row.vendorId;
      this.myObj.Name = row.Name;
      this.myObj.Status = row.Status;
    },

    async Add() {
      if (
        this.myObj.id == 0 &&
        this.limit == this.$store.state.branches.length
      ) {
        this.$bvToast.toast(
          this.$t("You have reached your limit.Please Contact MySkool Team."),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      } else {
        // console.log("req:", this.request);
        // this.CheckLogo();
        this.CheckWebsite();
        // this.CheckEmail();
        this.CheckName();
        this.CheckAddress();
        this.CheckBranch();
        this.CheckPhone();
        this.CheckMobile();

        if (
          // this.CheckLogo() == true ||
          this.CheckWebsite() == false ||
          // this.CheckEmail() == false ||
          this.CheckName() == false ||
          this.CheckAddress() == false ||
          this.CheckBranch() == false ||
          this.CheckPhone() == true ||
          this.CheckMobile() == true
        ) {
          this.$bvToast.toast(this.$t("Please fill the form correctly."), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        } else {
          this.applyCompanyIdsBeforeSave();
          this.request = true;
          // console.log(this.myObj);
          if (this.myObj.id == 0) {
            var status = await this.post({
              url:
                this.$store.state.domain +
                "campuses?db=" +
                this.$store.state.userData.db +
                "&cId=" +
                this.$store.state.userData.cId,
              body: this.myObj,
              message: this.$t("Campus added successfully."),
              token: this.$store.state.userData.token,
              context: this,
            });
            this.request = false;
            //this.visibility1 = false;
            if (status) {
              this.$router.push("/manage-branches");
            }
          } else {
            //Edit
            var status = await this.put({
              url:
                this.$store.state.domain +
                "campuses/" +
                this.myObj.id +
                "?db=" +
                this.$store.state.userData.db +
                "&cId=" +
                this.$store.state.userData.cId,
              body: this.myObj,
              message: this.$t("Campus updated successfully."),
              token: this.$store.state.userData.token,
              context: this,
            });
            this.request = false;
            if (status) {
              this.$router.push("/manage-branches");
            }
          }
        }
      }
    },

    LoadForm() {
      //console.log(this.myrow ,"This.lOad Form");
      if (this.myrow == undefined) {
        return 0;
      } else {
        this.myObj = { ...this.myrow.row };
        if (this.myObj.cover == null) this.myObj.cover = "";
        if (this.myObj.campusCode == null) this.myObj.campusCode = "";
        // console.log(this.myObj);
        if (this.isIussDomain) {
          this.syncCompanySelectionFromCampus();
        }
        if (this.myObj.logo) {
          this.plus = this.myObj.logo;
          this.logoPreviewFailed = false;
          this.logoloading = "loaded";
        } else {
          this.plus = "";
          this.logoPreviewFailed = false;
          this.logoloading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes slideUpFade {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.campus-form-page {
  padding: 0.75rem 0 2.5rem;
  max-width: 980px;
  margin: 0 auto;
}

.campus-header-card,
.campus-form-card {
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  border: 1px solid #e0d8ff;
  border-radius: 20px;
  padding: 1.5rem 1.75rem;
  box-shadow: 0 10px 30px rgba(115, 103, 240, 0.12);
  position: relative;
  overflow: hidden;
  animation: slideUpFade 0.4s ease-out both;

  ::v-deep .card-body {
    padding: 0;
  }
}

.campus-header-card {
  margin-bottom: 1.25rem;
}

.campus-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.back-btn {
  width: 48px;
  height: 48px;
  min-width: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px !important;
  border: 2px solid #e0d8ff !important;
  background: #fff !important;
  color: #7c5dfa !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(124, 93, 250, 0.1);

  &:hover {
    transform: translateX(-3px);
    background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%) !important;
    color: #fff !important;
    border-color: #7c5dfa !important;
  }
}

.title-wrapper {
  flex: 1;
  min-width: 200px;

  h4 {
    font-size: 1.35rem;
    font-weight: 800;
    color: #2d1b69;
    letter-spacing: -0.3px;
  }

  .badge-pill {
    font-weight: 600;
    font-size: 0.78rem;
    padding: 0.35rem 0.75rem;
  }

  small {
    display: block;
    margin-top: 0.35rem;
    font-weight: 500;
    color: #6b7280;
  }
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-left: auto;
}

.cancel-btn {
  border-radius: 12px !important;
  font-weight: 600;
  border-color: #e0d8ff !important;
  min-height: 42px;
}

.save-campus-btn {
  border-radius: 12px !important;
  font-weight: 700;
  min-height: 42px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  background: linear-gradient(135deg, #10b981 0%, #34d399 100%) !important;
  border: none !important;
  box-shadow: 0 4px 16px rgba(16, 185, 129, 0.35);
  transition: all 0.25s ease;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 22px rgba(16, 185, 129, 0.45);
  }
}

.form-section {
  & + & {
    margin-top: 1.75rem;
    padding-top: 1.75rem;
    border-top: 2px solid #f0edff;
  }

  &--fields {
    animation: slideUpFade 0.45s ease-out 0.08s both;
  }
}

.section-head {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1.25rem;

  &__title {
    font-size: 1.1rem;
    font-weight: 800;
    color: #2d1b69;
  }
}

.campus-branding {
  border-radius: 16px;
  overflow: hidden;
  border: 1.5px solid #e0d8ff;
  background: #fff;
  box-shadow: 0 4px 18px rgba(124, 93, 250, 0.08);
}

.campus-form-cover {
  position: relative;
  height: 168px;
  border-radius: 0;
  overflow: hidden;
  background: linear-gradient(135deg, #eef0ff 0%, #e0d8ff 55%, #f3efff 100%);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: box-shadow 0.25s ease;

  &:hover {
    box-shadow: 0 8px 24px rgba(124, 93, 250, 0.15);
  }

  &--has-image {
    background: #1a1033;
  }

  &__img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.4rem;
    color: #7c5dfa;
    z-index: 1;
    font-weight: 600;
    font-size: 0.9rem;
  }

  &__loading {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(45, 27, 105, 0.45);
    z-index: 2;
  }

  &__actions {
    position: absolute;
    bottom: 0.75rem;
    right: 0.75rem;
    z-index: 3;
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem;
  }
}

.cover-action-btn {
  border-radius: 10px !important;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
}

.campus-form-logo-block {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem 1.25rem;
  margin: 0;
  padding: 1.1rem 1.25rem 1.25rem;
  background: #fff;
  border-top: 1px solid #f0edff;
}

.campus-form-logo-wrap {
  position: relative;
  flex-shrink: 0;
  width: 5.5rem;
  height: 5.5rem;
  border-radius: 50%;
  border: 4px solid #fff;
  background: #fff;
  box-shadow: 0 6px 20px rgba(34, 41, 47, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
}

.campus-form-logo__img,
.campus-form-logo__empty,
.campus-form-logo__spin {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: none;
  box-shadow: none;
  object-fit: contain;
  object-position: center;
  background: #fff;
  box-sizing: border-box;
  padding: 0.4rem;
}

.campus-form-logo__img {
  display: block;
}

.campus-form-logo__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7c5dfa;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.03);
  }
}

.campus-form-logo__spin {
  display: flex;
  align-items: center;
  justify-content: center;
}

.campus-form-logo__hint {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.35rem;
  flex: 1;
  min-width: 0;
}

.logo-sublabel {
  font-size: 0.78rem;
  line-height: 1.35;
  max-width: 22rem;
}

.logo-label {
  display: block;
  font-weight: 800;
  color: #2d1b69;
  font-size: 0.95rem;
  line-height: 1.2;
  margin: 0;
}

.logo-upload-btn {
  border-radius: 10px !important;
  font-weight: 600;
  margin-top: 0 !important;
  display: inline-flex;
  align-items: center;
}

.campus-form-logo__remove {
  position: absolute;
  top: -2px;
  right: -2px;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(234, 84, 85, 0.35);
}

.campus-field-group {
  margin-bottom: 1.1rem;

  ::v-deep label {
    font-weight: 700;
    font-size: 0.82rem;
    color: #4b5563;
    letter-spacing: 0.02em;
  }
}

.field-hint {
  display: block;
  margin-top: 0.35rem;
  font-size: 0.78rem;
  color: #9ca3af;
}

.campus-field-input {
  border-radius: 12px !important;
  border: 1.5px solid #e0d8ff !important;
  min-height: 44px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: #9d7aff !important;
    box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.15) !important;
  }

  &--code {
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
}

.campus-tel-wrap {
  ::v-deep .vue-tel-input {
    border-radius: 12px;
    border: 1.5px solid #e0d8ff;
    min-height: 44px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &:focus-within {
      border-color: #9d7aff;
      box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.15);
    }
  }

  ::v-deep input {
    border: none !important;
    min-height: 42px;
  }
}

.campus-companies-select {
  ::v-deep .vs__dropdown-toggle {
    border-radius: 12px;
    border: 1.5px solid #e0d8ff;
    min-height: 44px;
    padding: 4px 8px;
  }

  ::v-deep &.vs--open .vs__dropdown-toggle {
    border-color: #9d7aff;
    box-shadow: 0 0 0 3px rgba(124, 93, 250, 0.12);
  }
}

@media (max-width: 767px) {
  .header-actions {
    width: 100%;
    margin-left: 0;
    justify-content: flex-end;
  }

  .campus-header-card,
  .campus-form-card {
    padding: 1.15rem;
  }

  .campus-form-logo-block {
    padding: 1rem;
  }

  .campus-form-cover {
    height: 140px;
  }
}

@media (max-width: 575px) {
  .campus-form-logo-block {
    flex-direction: column;
    align-items: flex-start;
  }

  .campus-form-logo-wrap {
    align-self: center;
  }

  .campus-form-logo__hint {
    width: 100%;
    align-items: center;
    text-align: center;
  }

  .logo-upload-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
